export const login = "/login";
export const splash = "/splash";
export const reward = "/reward";
export const rewardPointSummary = "/point-summary";
export const home = "/home";
export const create = "/create";
export const createReport = "/createReport";
export const support = "/support";
export const supportContact = "/contact";
export const account = "/account";
export const forgotPassword = "/forgot-password";
export const changePassword = "/change-password";
export const setting = "/setting";
export const editProfile = "/edit-profile";
export const editAvatarProfile = "/edit-avatar-profile";
export const showMyQrCode = "/show-my-qr-code";
export const pointHistory = "/point-history";
export const showMyCard = "/show-my-card";
export const starHistory = "/star-history";
export const myVoucher = "/myvoucher";
export const rewardVoucher = "/reward/voucher";
export const rewardEvoucher = "/reward/e-voucher";
export const rewardEcommerce = "/reward/e-commerce";
export const rewardDonation = "/reward/donation";
export const privacy_policy = "/privacy_policy";
export const terms_and_condition = "/terms_and_condition";
export const rewardVoucherDetail =
  "/reward/voucher/:url_category/detail/:voucherId";
export const myVoucherDetail = "/myvoucher/detail/:voucherId";
export const supportChat = "/support-chat";
export const summaryInfo = "/summary-info/:typeInfo";
export const underDevelopment = "/under-development";
export const news = "/news";
export const detailNews = "/news/detail";
export const homePointSummary = "/home/point-summary";
export const quiz = "/quiz";
export const quizCategory = "/quiz/:categoryId";
export const quizQuestion = "/quiz/:categoryId/:quizId";
export const quizResult = "/quiz/:categoryId/:quizId/result";
export const discountVoucher = "/reward/discount";
export const discountVoucherDetail =
  "/reward/discount/:url_category/detail/:voucherId";
export const nearMe = "/nearme";
export const survey = "/survey";
export const surveyQuestion = "/survey/:surveyId";
export const announcement = "/announcement";
export const announcementDetail = "/announcement/:announcementId";
export const announcementListLikes = "/announcement/:announcementId/likes";
export const loginOrg = "/login";
export const loginOrgBySlug = "/auth/login";
export const polling = "/polling";
export const pollingFill = "/polling/:pollingId";
export const pollingResult = "/polling/:pollingId/result";
export const pollingComment = "/polling/:pollingId/result/comments";
export const event = "/event";
export const eventDetail = "/event/detail";
export const leaderboard = "/leaderboard";
export const noInternetConnection = "/no-internet-connection";
export const cashTransfer = "/reward/cash-transfer/:id";
export const listBank = "/list-bank";
export const report = "/report";
export const calendar = "/calendar";
export const calendarAddReminder = "/calendar/add-reminder";
export const blocklist = "/blocklist";
export const snapReceipt = "/snap-receipt";
